/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Permonth1Inputs */

const zh_landing_pricing_permonth1 = /** @type {(inputs: Landing_Pricing_Permonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/月`)
};

const en_landing_pricing_permonth1 = /** @type {(inputs: Landing_Pricing_Permonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/month`)
};

const es_landing_pricing_permonth1 = /** @type {(inputs: Landing_Pricing_Permonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mes`)
};

/**
* | output |
* | --- |
* | "/month" |
*
* @param {Landing_Pricing_Permonth1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_pricing_permonth1 = /** @type {((inputs?: Landing_Pricing_Permonth1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Permonth1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_pricing_permonth1(inputs)
	if (locale === "en") return en_landing_pricing_permonth1(inputs)
	return es_landing_pricing_permonth1(inputs)
});
export { landing_pricing_permonth1 as "landing_pricing_perMonth" }